import { useQuery } from "@tanstack/react-query";
import { ExportXlsx } from "../export-xlsx";

export const useExportDownloads = (filter: string) => {
  const { refetch } = useQuery({
    queryKey: ["Export"],
    queryFn: () => ExportXlsx("downloads", filter),
    enabled: false,
  });

  return { refetch };
};
